const DpoZaznamy = {
    internval: null,
    driveUzamcemo: false,

    initBeacon: function () {
        const sectionId = $('#idSection').val();
        if (!sectionId) {
            return;
        }

        const itemId = $('#idItem').val();
        if (!itemId) {
            return;
        }

        if (!navigator.sendBeacon) {
            return;
        }

        const path = window.location.pathname;
        if (!path.includes("edit")) {
            const tlacitkoEmailAdmin = $("#tlacitkoOdeslatEmail");
            const tlacitkoEmailZadatel = $("#tlacitkoZadatelOdeslatEmail");
            if (!tlacitkoEmailAdmin.length && !tlacitkoEmailZadatel.length) {
                return;
            }
        }

        window.addEventListener("beforeunload", DpoZaznamy.odemknoutBeacon);

        DpoZaznamy.uzamknout(sectionId, itemId);
    },

    odemknoutBeacon: function () {
        if (null !== DpoZaznamy.internval) {
            window.clearInterval(DpoZaznamy.internval);
            DpoZaznamy.internval = null;
        }

        if (!navigator.sendBeacon) {
            return true;
        }

        const sectionId = $('#idSection').val();
        if (!sectionId) {
            return true;
        }

        const itemId = $('#idItem').val();
        if (!itemId) {
            return true;
        }

        let url = window.location.protocol + "//" + window.location.host;
        url += "/dpo/zaznamy/odemknout";

        let data = new FormData();
        data.append("itemId", itemId);
        data.append("sectionId", sectionId);

        const _ch = $("#_ch");
        if (_ch.length) {
            data.append("_ch", _ch.val());
        }

        navigator.sendBeacon(url, data);

        return true;
    },

    uzamknout: function (sectionId, itemId) {
        let _ch = $("#_ch").val();
        if (!_ch) {
            _ch = null;
        }

        let url = window.location.protocol + "//" + window.location.host;
        url += "/dpo/zaznamy/uzamknout";

        let data = {};
        data["_ch"] = _ch;
        data['sectionId'] = sectionId;
        data['itemId'] = itemId;

        $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            data: data,
            global: false,
            success: function (r) {
                if (false === r["status"]) {
                    let message = "Záznam se nepodařilo uzamknout pro úpravy.";
                    if (r["message"]) {
                        message = r["message"];
                    }

                    const uzivatelInfo = DpoZaznamy.uzivatelInfo(r);

                    DpoZaznamy.upozorneni(sectionId, itemId, message, uzivatelInfo);
                    DpoZaznamy.driveUzamcemo = true;
                } else if (true === DpoZaznamy.driveUzamcemo) {
                    Lemo_Modal.close();
                    window.location.reload();
                }

                if (null === DpoZaznamy.internval) {
                    DpoZaznamy.internval = window.setInterval(function (sectionId, itemId) {
                        DpoZaznamy.uzamknout(sectionId, itemId);
                    }, 10000, sectionId, itemId);
                }
            }
        });
    },

    upozorneni: function (sectionId, itemId, message, uzivatelInfo) {
        let text = '<p class="text text-center font-weight-bold">';
        text += message
        text += "</p>";
        text += '<div class="text-center">';
        text += '<i class="fa fa-lock-alt fa-fw fa-5x mt-3 mb-4 text-danger"></i>';
        text += "</div>";
        text += "<p class='text text-center'>";
        text += "Můžete čekat, až bude záznam uvolněn pro editaci,<br>nebo jej zavřít a pokračovat v jiné práci.";
        text += "</p>";
        text += uzivatelInfo;

        Lemo_Modal.setTitle('<i class="fas fa-fw fa-lock-alt"></i> Uzamčeno' );
        Lemo_Modal.setContent(text);
        Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> Zavřít', 'btn btn-secondary', function() {
            let url = window.location.href;
            url = url.replace("/item/detail", '/item');
            url = url.replace("/item/edit", '/item');
            url = url.replace(/\d+\//, "");
            window.location.href = url;
        });
        Lemo_Modal.enableClose(false);
        Lemo_Modal.disableSubmitOnEnter();
        Lemo_Modal.build(null);
    },

    uzivatelInfo: function (data) {
        let text = '';
        if (data.hasOwnProperty("jmeno")) {
            text += "<p class='text text-center font-weight-bold'>";
            text += "Informace o uživateli:";
            text += "</p>";
            text += "<p class='text text-center'>";
            text += data["jmeno"];
            text += "</p>";

            text += "<p class='text text-center'>";
            if (data.hasOwnProperty("uzivatelskeJmeno")) {
                text += "Uživatelské jméno: " + data["uzivatelskeJmeno"] + "<br>";
            }

            if (data.hasOwnProperty("email")) {
                text += "Email: " + data["email"] + "<br>";
            }

            if (data.hasOwnProperty("telefon")) {
                text += "Telefon: " + data["telefon"] + "<br>";
            }

            if (data.hasOwnProperty("ip")) {
                text += "Počítač: " + data["ip"] + "<br>";
            }

            if (data.hasOwnProperty("prohlizec")) {
                text += "Prohlížeč: " + data["prohlizec"];
            }

            text += "</p>";

        } else {
            return text;
        }


        return text;
    }
}

$(document).ready(function () {
    DpoZaznamy.initBeacon();
});
